import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, inject, PLATFORM_ID, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { Result } from '@unimarket/shared';
import { filter } from 'rxjs';

import { CartService } from '../../service/cart.service';
import { MoneyPipe } from '../../money.pipe';

/** The cart dropdown behind the header icon, and the icon's item counter. */
@Component({
  selector: 'header-cart-icon',
  imports: [RouterLink, MoneyPipe],
  template: `
    <div class="header-wrapicon2">
      <img src="/images/icons/icon-header-02.png" class="header-icon1 js-show-header-dropdown" alt="ICON">
      <span class="header-icons-noti">{{cart().products.length}}</span>

      <!-- Header cart noti -->
      <div class="header-cart header-dropdown">
        @if (lastChange().error; as refusal) {
          <p class="text-center m-text8 p-t-10">{{refusal}}</p>
        }
        @if (cart().products.length) {
          <ul class="header-cart-wrapitem p-t-5">
            @for (product of cart().products; track product.productId) {
              <li class="header-cart-item">
                <div class="header-cart-item-img">
                  <button style="right: -20px; position: absolute; top: -10px;" (click)="remove(product.productId)">
                    <span class="fa fa-lg fa-times-circle"></span>
                  </button>
                  <a [routerLink]="product.uri">
                    @if (product.photo) {
                      <img [src]="product.photo" [alt]="product.name">
                    }
                  </a>
                </div>

                <div class="header-cart-item-txt">
                  <a class="header-cart-item-name" [routerLink]="product.uri">
                    {{product.name}}
                  </a>

                  <span class="header-cart-item-info">
                    {{product.quantity}} x {{product.price | money}}
                  </span>
                </div>
              </li>
            }
          </ul>

          <div class="header-cart-total">
            Загалом: {{cart().total | money}}
          </div>

          <div class="header-cart-buttons">
            <div class="header-cart-wrapbtn"></div>

            <div class="header-cart-wrapbtn">
              <!-- Button -->
              <a routerLink="/cart" class="flex-c-m size1 bg1 bo-rad-23 hov1 s-text1 trans-0-4" (click)="close()">
                Замовити
              </a>
            </div>
          </div>
        } @else {
          <p class="text-center">
            Кошик порожній. <a class="fglight" routerLink="/products">Додати товари?</a>
          </p>
        }
      </div>
    </div>
    `
})
export class HeaderCartIconComponent {

  private cartService = inject(CartService);

  readonly cart = this.cartService.cart;
  readonly lastChange = signal(Result.ok());

  private router = inject(Router);
  private document = inject(DOCUMENT);
  private browser = isPlatformBrowser(inject(PLATFORM_ID));

  constructor() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd), takeUntilDestroyed())
      .subscribe(() => {
        this.lastChange.set(Result.ok());
        this.close();
      });
  }

  /**
   * The theme's jQuery opens the dropdown and closes it only on a click outside, so neither a
   * navigation nor a click inside reaches it. Navigating to the page already shown fires no
   * navigation event at all, which is why the link calls this as well. Sending the theme the
   * click it waits for, rather than dropping its class, keeps its own idea of what is open right.
   */
  close() {
    if (this.browser) {
      this.document.defaultView?.dispatchEvent(new Event('click'));
    }
  }

  async remove(productId: number) {
    const page = this.router.url;
    const result = await this.cartService.remove(productId);
    // Otherwise a refusal that lands after a click elsewhere would show on the next page.
    if (this.router.url === page) {
      this.lastChange.set(result);
    }
  }

}
